import { createContext, use } from 'react';
import invariant from 'tiny-invariant';

export type ToastContextValue = {
	dismiss: () => void;
};

/**
 * This context only exists as a DX convenience so we don't have to relay arguments to the `<Toast>` component every
 * time we call `addToast()`. The arguments are "wirelessly" passed from the `addToast` function internals
 * (see `toast-store.tsx`) to the `<Toast>` component via this context.
 */
export const ToastContext = createContext<ToastContextValue | null>(null);

export const useToastContext = () => {
	const context = use(ToastContext);
	invariant(context, 'ToastContext not provided');
	return context;
};
